import React from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { I18n } from '@interlayer/js/components/common/I18n';

import { useTranslations } from '@core/js/hooks/i18n';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TTooltipPassword } from './types';

import style from './TooltipPassword.scss';

const MarkIcon: React.FC<{ isValid: boolean }> = ({ isValid }) => {
    return (
        <>
            <SvgIcon
                className={clsx(style.ruleIcon, style.valid, { hidden: !isValid })}
                type="valid"
            />

            <SvgIcon
                className={clsx(style.ruleIcon, style.invalid, { hidden: isValid })}
                type="invalid"
            />
        </>
    );
};

export const TooltipPassword: TTooltipPassword = ({
    titleKey = 'password.panel.title',
    password,
    criteria,
    isShow,
    isDefaultIcon,
    classNames = {}
}) => {
    const t = useTranslations('playtech.mobile.system.registration.validation.');

    return (
        <div
            className={clsx(style.container, classNames.container, {
                [style.isShow]: isShow,
                [classNames.isShow]: isShow
            })}
        >
            <I18n
                t={t}
                tKey={titleKey}
                className={style.title}
            />

            {criteria.map((rule, index) => {
                const { fn, label } = typeof rule === 'string'
                    ? { label: rule, fn: null }
                    : rule;
                const isValid = Boolean(fn && password && fn(password));

                return (
                    <div key={index} className={style.rule}>
                        {isDefaultIcon
                            ? <div className={style.mark} />
                            : <MarkIcon isValid={isValid} />
                        }

                        <I18n
                            t={t}
                            tKey={label}
                            className={style.ruleMessage}
                        />
                    </div>
                );
            })}
        </div>
    );
};
